import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AddSpocToProjectRPC } from "./addSpocToProjectRPC";

export class AddSpocToProjectRPCClientImpl extends AddSpocToProjectRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AddSpocToProjectRPC.Request): Promise<LeoRPCResult<AddSpocToProjectRPC.Response, AddSpocToProjectRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/AddSpocToProject",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AddSpocToProjectRPC.ResponseDTO,
      AddSpocToProjectRPC.Errors.ErrorsDTO,
      AddSpocToProjectRPC.Response,
      AddSpocToProjectRPC.Errors.Errors
    >(
      response,
      "spoc-management/AddSpocToProject",
      AddSpocToProjectRPC.Response.fromDTO,
      AddSpocToProjectRPC.Errors.fromDTO
    );
  }
}
